export const ALL_PIPELINES = 'ALL_PIPELINES';
export const MULTI_BUT_NOT_ALL_PIPELINES = 'multi-but-not-all-pipelines';